"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlToSearchState = exports.searchStateToUrl = exports.createURL = exports.$$ = exports.$ = void 0;
var qs_1 = __importDefault(require("qs"));
function $(selector, scope) {
    if (scope === void 0) { scope = document; }
    return scope.querySelector(selector);
}
exports.$ = $;
function $$(selector, scope) {
    if (scope === void 0) { scope = document; }
    return Array.from(scope.querySelectorAll(selector));
}
exports.$$ = $$;
exports.createURL = function (state) { return "?" + qs_1.default.stringify(state); };
exports.searchStateToUrl = function (location, searchState) {
    return searchState ? "" + location.pathname + exports.createURL(searchState) : '';
};
exports.urlToSearchState = function (location) { return qs_1.default.parse(location.search.slice(1)); };
